import { PageHeader } from "../components/nk/PageHeader";
import { Process } from "../components/nk/Process";
import { EditorialMarquee } from "../components/nk/EditorialMarquee";
import { CtaBand } from "../components/nk/CtaBand";
import { Seo } from "../components/nk/Seo";

export default function ProcessPage() {
  return (
    <>
      <Seo
        title="The Bespoke Process — From Sketch to 'I Do' · Perth | NK Bridal"
        description="See how NK Bridal creates a one-of-a-kind wedding gown in Perth — from first sketch and fittings to the final hand-finished seam. Bespoke bridal by a Brisbane seamstress."
        path="/process"
      />
      <PageHeader
        eyebrow="The Experience"
        title={["From first", "sketch to", "\u201CI do\u201D"]}
        intro="Every NK Bridal gown is a collaboration. Here's how your one-of-a-kind dress comes to life — from the first conversation to the final hand-finished seam."
      />
      <Process />
      <EditorialMarquee />
      <CtaBand />
    </>
  );
}
